// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Team.css */
.MuiDataGrid-columnsPanel .MuiSwitch-root .MuiSwitch-switchBase {
  color: white !important; /* Thumb color when off */
}

.MuiDataGrid-columnsPanel .MuiSwitch-root .MuiSwitch-track {
  background-color: gray !important; /* Track color when off */
  opacity: 0.5 !important;
}

.MuiDataGrid-columnsPanel .MuiSwitch-root .MuiSwitch-switchBase.Mui-checked {
  color: white !important; /* Thumb color when on */
}

.MuiDataGrid-columnsPanel .MuiSwitch-root .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  background-color: #33B0FF !important; /* Track color when on */
  opacity: 0.7 !important;
}

/* Set column names to dark gray */
.MuiDataGrid-columnsPanel .MuiFormControlLabel-label {
  color: #777676 !important; /* Dark gray for column names */
}

/* Set Hide All and Show All buttons to match column names' dark gray */
.MuiDataGrid-toolbarContainer .MuiButton-text {
  color: #777676 !important; /* Dark gray for buttons, matching column names */
}`, "",{"version":3,"sources":["webpack://./src/scenes/team/Team.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,uBAAuB,EAAE,yBAAyB;AACpD;;AAEA;EACE,iCAAiC,EAAE,yBAAyB;EAC5D,uBAAuB;AACzB;;AAEA;EACE,uBAAuB,EAAE,wBAAwB;AACnD;;AAEA;EACE,oCAAoC,EAAE,wBAAwB;EAC9D,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA,uEAAuE;AACvE;EACE,yBAAyB,EAAE,iDAAiD;AAC9E","sourcesContent":["/* Team.css */\n.MuiDataGrid-columnsPanel .MuiSwitch-root .MuiSwitch-switchBase {\n  color: white !important; /* Thumb color when off */\n}\n\n.MuiDataGrid-columnsPanel .MuiSwitch-root .MuiSwitch-track {\n  background-color: gray !important; /* Track color when off */\n  opacity: 0.5 !important;\n}\n\n.MuiDataGrid-columnsPanel .MuiSwitch-root .MuiSwitch-switchBase.Mui-checked {\n  color: white !important; /* Thumb color when on */\n}\n\n.MuiDataGrid-columnsPanel .MuiSwitch-root .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {\n  background-color: #33B0FF !important; /* Track color when on */\n  opacity: 0.7 !important;\n}\n\n/* Set column names to dark gray */\n.MuiDataGrid-columnsPanel .MuiFormControlLabel-label {\n  color: #777676 !important; /* Dark gray for column names */\n}\n\n/* Set Hide All and Show All buttons to match column names' dark gray */\n.MuiDataGrid-toolbarContainer .MuiButton-text {\n  color: #777676 !important; /* Dark gray for buttons, matching column names */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
